enum COURSE_ACTIONS {
  FETCH_COURSE_INSTANCE = 'FETCH_COURSE_INSTANCE',
  FETCH_COURSE_DETAILS = 'FETCH_COURSE_DETAILS',
  FETCH_COURSE_PROGRESS = 'FETCH_COURSE_PROGRESS',
  CLEAR_COURSE_DETAILS = 'CLEAR_COURSE_DETAILS',
}

export default COURSE_ACTIONS;
